import {
  DATA_CONNECTOR_GET_EXTERNAL_DATA_BASE_BEGIN,
  DATA_CONNECTOR_GET_EXTERNAL_DATA_BASE_SUCCESS,
  DATA_CONNECTOR_GET_EXTERNAL_DATA_BASE_FAILURE,
  DATA_CONNECTOR_GET_EXTERNAL_DATA_BASE_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import axios from 'axios';

export function getExternalDataBase(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DATA_CONNECTOR_GET_EXTERNAL_DATA_BASE_BEGIN,
    });
    const { projectId, version } = args
    let header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      let url = `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/external-api/get-externaldb`;
      if (args.type) {
        url = `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/external-api/get-externaldb?type=${args.type}`;
      }
      const doRequest = axios.get(url, header);
      doRequest.then(
        (res) => {
          dispatch({
            type: DATA_CONNECTOR_GET_EXTERNAL_DATA_BASE_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },

        (err) => {
          dispatch({
            type: DATA_CONNECTOR_GET_EXTERNAL_DATA_BASE_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}


export function dismissGetExternalDataBaseError() {
  return {
    type: DATA_CONNECTOR_GET_EXTERNAL_DATA_BASE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DATA_CONNECTOR_GET_EXTERNAL_DATA_BASE_BEGIN:

      return {
        ...state,
        getExternalDataBasePending: true,
        getExternalDataBaseError: null,
      };

    case DATA_CONNECTOR_GET_EXTERNAL_DATA_BASE_SUCCESS:

      return {
        ...state,
        getExternalDataBasePending: false,
        getExternalDataBaseError: null,
        externalDataBaseData: action.data
      };

    case DATA_CONNECTOR_GET_EXTERNAL_DATA_BASE_FAILURE:

      return {
        ...state,
        getExternalDataBasePending: false,
        getExternalDataBaseError: action.data.error,
      };

    case DATA_CONNECTOR_GET_EXTERNAL_DATA_BASE_DISMISS_ERROR:

      return {
        ...state,
        getExternalDataBaseError: null,
      };

    default:
      return state;
  }
}
